import { ITooltipParams } from 'ag-grid-enterprise';
import { Chip } from '@mui/material';
import React from 'react';

export const DefaultAgGridTooltip = (props: ITooltipParams) => {
  return <Chip label={props.value} sx={{ fontSize: '11px', backgroundColor: 'black', color: 'white', }}  size="small" />;
};
